import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/primitives/button";

/**
 * Error component for file attachments
 * Displays an error message and retry button when file loading fails
 */
interface FileAttachmentErrorProps {
  onRetry: () => void;
}

export default function FileAttachmentError({
  onRetry,
}: FileAttachmentErrorProps) {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 p-4">
      <AlertCircle className="size-8 text-destructive" />
      <p className="text-center text-sm text-muted-foreground">
        {t("error_loading_files", "Error loading files")}
      </p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        {t("retry", "Retry")}
      </Button>
    </div>
  );
}
